
import mobileStore from "/assets/icons/mobile-store.png";
import electric from "/assets/icons/electric.png";
import clothesStore from "/assets/icons/clothes-store.png";
import carpet from "/assets/icons/carpet.png";
import pharmacy from "/assets/icons/pharmacy.png";
import homeAppliances from "/assets/icons/home_appliances.png";
import addProducts from "/assets/addproduct.png";
import warehouse from "/assets/warehouse.png";
import accountParties from "/assets/account_parties.png";
import saleAndBuy from "/assets/sale_buy.png";
import users from "/assets/users.png";
import reports from "/assets/reports.png";
import market from "/assets/icons/market.png";


export const businesses = [
    {
        icon: clothesStore,
        iconWidth: 55,
        iconHeight: 55,
        title: "جل و بەرگ و کوزموتیک",
    },
    {
        icon: mobileStore,
        iconWidth: 50,
        iconHeight: 50,
        title: "موبایل و اکسسوارات",
    },

    {
        icon: pharmacy,
        iconWidth: 50,
        iconHeight: 50,
        title: "دەرمانخانە",
    },
    {
        icon: market,
        iconWidth: 45,
        iconHeight: 45,
        title: "مارکێت",
    },
    {
        icon: carpet,
        iconWidth: 55,
        iconHeight: 55,
        title: "کەل و پەلێن راخستنێ",
    },
    {
        icon: electric,
        iconWidth: 55,
        iconHeight: 55,
        title: "کەهرەبایی",
    },

    {
        icon: homeAppliances,
        iconWidth: 55,
        iconHeight: 55,
        title: "ئامیرێن ناڤ مالێ",
    },
];

export const importantParts = [
    {
        id: "addProducts",
        title: "زێدەکرنا کەرەستان",
        description:
            "ل ڤی بەشی تو دشێ بساناهی کەرەستە و خرمەتگوزاریێن جهێ خو ب هەمی تایبەتمەندیێت خوڤە زێدە بکەی کو پێک دهێت ژ: بهایێ کرینێ, بهایێ فروتنێ, جورێ کەرەستەی, پیڤەر, بارکود و هەروەسا ئاگەهداریا نەمان و سەرداچوونا ماوێ کەرەستەی ژی دا باشتر بشێی کونترولا کەرەستێن خو بکەی.",
        img: addProducts,
    },
    {
        id: "warehouse",
        title: "کوگەھ",
        description: "ل ڤی بەشی ئەو کەرەستێن تە هەی دگەل هەژمارا وان دێ بوتە دیاربیت داکو بساناهی بشێ جەردا وان بکەی و بزانی بو هەر کەرەستە ئان جورێ کەرەستەی تە ب بهایێ چەندێ ل ناڤا کوگەهێ دا هەیە.",
        img: warehouse,
    },
    {
        id: "accountParties",
        title: "لایەنێن بەرامبەر",
        description: "ل ڤی بەشی دێ بوتە لایەنێن تەیێن بەرامبەر دیار بیت کو پێک دهێن ژ کڕیار و دابینکەرێن تە, هەروەسا دیتنا حسێبێن کەڤن و کرین و فروتنێت وان دگەل بەشێ پارە دانێ ",
        img: accountParties,
    },
    {
        id: "saleAndPurchases",
        title: "کرین و فروتن",
        description:
            "ل ڤان بەشا تو دشێ کرین و فروتنێ بکەی ب شێوازێ کەت و کوم,ئەڤ بەشە ئێکە ژ پڕکارترین بەشان ژبەرهندێ ئێک ژ گرنگترین تایبەتمەندیێت شول لسەر هایتە کرن فێرێ دا ئەوە کو ئەڤ پروسەیە بساناهیترین و زیترین دەم بهێتە کرن.",
        img: saleAndBuy,
    },
    {
        id: "users",
        title: "بکارهێنەر",
        description: "ل ڤی بەشی تو دشێ بکارهێنەرێن خو پێناسە بکەی و بو هەر ئێک ژ وا روڵەکێ دیار بکەی, داکو بکارئینانا ئەپلیکەیشنی ل دەف وان لبن چاڤدێری و دەستهەلاتا تەدابیت.",
        img: users,
    },
    {
        id: "Reports",
        title: "راپورت",
        description: "پێک دهێت ژ راپورتێن کرین و فروتنێ, زانینا داهات و قازانجێن فروتنێ ل دیف بەروارێ دیاری کری.",
        img: reports,
    },
];

export const Questions = [
    {
        question: "فێربوونا ئەپلیکەیشنی چاوایە؟",
        answer: "ژبەر سادەیی یا روکارێ وێ هەرکەسەک دێ شێت بساناهی فێربیت و بکاربینیت. دگەل دانانا سیستەمی فێرکاری دێ هێتە پێشکێش کرن. دگەل هندێ پشتگیری دێ هەبیت بو هەر کێشەکێ د بکارئینانێ دا.",
        isOpen: false,
    },
    {
        question: "ئەپلیکەیشن ب زمانێ کوردیە؟",
        answer: "بەلێ, ئەپلیکەیشن ب تمامی ب زمانێ کوردی-بادینی هاتییە دارێژتن.",
        isOpen: false,
    },
    {
        question: "ئەز دشێم لسەر چەند کومپیوتەرا بکاربینم؟",
        answer: "تودشێ لسەر چەندین کومپوتەران د ئێک دەم دا بکاربینی بێ بەرامبەر.",
        isOpen: false,
    },
    {
        question: "ئەپلیکەیشن بێ ئینتێرنێت ژی شول دکەت؟",
        answer: "بەلێ, ئەپلیکەیشن د بنەرەت دا ئوفلاینە و پێدڤی خەتی ناکەت بو شولکرنێ.",
        isOpen: false,
    },
    {
        question: "دێ شێم بارکودێ خویێ تایبەت چێکەم؟",
        answer: "بەلێ, تودشێ بو ئەو کەرەستێن بێ بارکود, بارکودێ تایبەت بدانی و چاپ بکەی هەر ناڤا ئەپلیکەیشنی بخودا.",
        isOpen: false,
    },
    {
        question: "دێ شێم برێکا موبایلا خو زانم کا روژانە چ دهێتە فروتن؟",
        answer: "بەلێ, ئەڤ تایبەتمەندی یە دێ شێت بهێتە زێدەکرن لدیف داخازیا تە.",
        isOpen: false,
    },
];